import type { ReactNode } from 'react';

interface Props {
  titulo: string;
  subtitulo?: string;
  aoFechar: () => void;
  children: ReactNode;
}

// Folha de baixo no celular, janela no desktop. A tela inteira nunca vira uma parede.
export default function PainelEditor({ titulo, subtitulo, aoFechar, children }: Props) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/40 sm:items-center sm:px-4"
      onClick={aoFechar}
    >
      <div
        className="flex max-h-[92vh] w-full flex-col overflow-hidden rounded-t-2xl border border-secondary-200 bg-white sm:max-w-[560px] sm:rounded-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 border-b border-secondary-100 px-5 py-4">
          <div className="min-w-0">
            <h2 className="truncate text-base font-medium text-foreground-950">{titulo}</h2>
            {subtitulo && <p className="mt-0.5 text-sm text-secondary-500">{subtitulo}</p>}
          </div>
          <button
            type="button"
            onClick={aoFechar}
            aria-label="Fechar"
            className="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-md text-secondary-500 transition-colors hover:bg-background-100 hover:text-foreground-800"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden px-5 py-5">{children}</div>
      </div>
    </div>
  );
}